// extracted by mini-css-extract-plugin
module.exports = {"brandContainer":"brands_brandContainer__nyA-w","brands":"brands_brands__39lFe"};